<template>
  <div id="app">
    <!-- Login/logout/404 render full-screen; everything else gets the nav chrome. -->
    <template-default v-if="showChrome">
      <router-view />
    </template-default>
    <router-view v-else />
  </div>
</template>

<script>
const BARE_ROUTES = ['Login', 'Logout', 'NotFound']

export default {
  computed: {
    showChrome() {
      return !BARE_ROUTES.includes(this.$route.name)
    },
  },
}
</script>
